import { z } from 'zod';
import { DataSyncBlockedReasonSchema } from './data-sync-difference.schema';
import { DataSyncSkippedReasonSchema } from './data-sync-run.schema';
/**
 * Why the source cannot supply a person: the data the source lacks. The
 * Abgleich blocks such a create or skips the person; the setup lists them.
 */ export const DataSyncUnsuppliedReasonSchema = z.enum([
    ...DataSyncBlockedReasonSchema.extract([
        'missingDepartment',
        'missingRole'
    ]).options,
    ...DataSyncSkippedReasonSchema.options
]);

//# sourceMappingURL=data-sync-unsupplied-reason.schema.js.map